// services/propertyType.service.ts
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IPropertyType } from "../propertyTypeModal";

export const getAllPropertyTypes = createAsyncThunk(
  "PropertyType/FindAllPropertyType",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PropertyType/FindAllPropertyType`,
        {
          Title: "",
        },
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Property Types:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createPropertyType = createAsyncThunk(
  "PropertyType/InsertPropertyType",
  async (propertyTypeData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PropertyType/InsertPropertyType`,
        propertyTypeData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Property Type:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updatePropertyType = createAsyncThunk(
  "PropertyType/UpdatePropertyType",
  async (propertyTypeData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PropertyType/UpdatePropertyType`,
        propertyTypeData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Property Type:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deletePropertyType = createAsyncThunk(
  "PropertyType/DeletePropertyType",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PropertyType/DeletePropertyType`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Property Type:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getPropertyTypeByID = createAsyncThunk(
  "PropertyType/FindByIDPropertyType",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PropertyType/FindByIDPropertyType`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result.Title,
        ImageUpload: result.ImageUpload,
        IsActive: result.IsActive ? 1 : 2,
      } as IPropertyType;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Property Type:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActivePropertyTypes = createAsyncThunk(
  "PropertyType/FindAllActivePropertyType",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/PropertyType/FindAllActivePropertyType`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Active Property Types:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const activeInactivePropertyType = createAsyncThunk(
  "PropertyType/ActiveInActivePropertyType",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PropertyType/ActiveInActivePropertyType`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Property Type:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// IMAGE UPLOAD
export const propertyTypeImageUpload = createAsyncThunk(
  "PropertyType/SingleImageUpload",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PropertyType/SingleImageUpload`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error uploading Property Type Image:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
